import { QRCode } from 'react-qrcode-logo'

// The branded QR encoding the `…/signup?invite=<code>` deep-link. A centre logo covers modules, so error
// correction MUST stay at H and the badge small, or it stops scanning. Canvas can't read CSS vars — hex is hard-coded.
const QR_SIZE = 202
const DOT_COLOR = '#25412e'
const LOGO_SIZE = 44 // ~22% of the QR — near the safe ceiling for an H-level code

interface Props {
  url: string
}

export default function InviteQrCode({ url }: Props) {
  return (
    // White card, white even in dark mode (design): border-radius 18, padding 18, inset shadow,
    // entrance scale/opacity animation.
    <div className="mb-[15px] flex items-center justify-center rounded-[18px] border border-border bg-white p-[18px] shadow-[inset_0_1px_3px_rgba(30,51,25,0.06)] motion-safe:animate-[qr-in_0.35s_cubic-bezier(0.2,0.8,0.3,1)]">
      <QRCode
        value={url}
        size={QR_SIZE}
        quietZone={6}
        ecLevel="H"
        qrStyle="dots"
        fgColor={DOT_COLOR}
        bgColor="#ffffff"
        eyeColor={DOT_COLOR}
        eyeRadius={8}
        logoImage="/parsley-leaf-badge.svg"
        logoWidth={LOGO_SIZE}
        logoHeight={LOGO_SIZE}
        logoPadding={3}
        logoPaddingStyle="circle"
        removeQrCodeBehindLogo
        style={{ width: QR_SIZE, height: QR_SIZE, display: 'block' }}
      />
    </div>
  )
}
